import React, { Component } from 'react';
import { Route, Redirect , Switch } from 'react-router-dom';
import routes from "../../routes";
import pageTitles from "../../helpers/pageTitles";
import pathList from "../../helpers/pathList";
import PublicRoute from "./PublicRoute";
import PrivateRoute from "./PrivateRoute";
import GeneralRoute from "./GeneralRoute";
import { Preloader } from "../../components/Preloader";

class RouteComponent extends Component {
  render() {
    return (
      <main>
        <Preloader/>
        <Switch>
          <PublicRoute exact={true} path={pathList.login.path} title={pageTitles.login} component={routes.Auth}/>
          <GeneralRoute path="/terms_n_condition" title="terms n condition" component={routes.Termsncondition} />
          <GeneralRoute path="/privacy_policy" title="privacy policy" component={routes.PrivacyPolicy} />
          <GeneralRoute path="/payment_policy" title="payment policy" component={routes.PaymentPolicy} />
          <GeneralRoute path="/refund_policy" title="refund policy" component={routes.RefundPolicy} />
          <GeneralRoute path="/subscription_cancellation_policy" title="refund policy" component={routes.SubscriptionCanellationPolicy} />
          <GeneralRoute path="/delivery_policy" title="refund policy" component={routes.DeliveryPolicy} />
          <GeneralRoute path="/contact_us" title="refund policy" component={routes.ContactUs} />
          <GeneralRoute path="/about_us" title="about us" component={routes.About} />
          <GeneralRoute path="/faq" title="FAQ" component={routes.FAQ} />
          <PublicRoute exact={true} path={pathList.registration.path} title={pageTitles.registration} component={routes.Auth}/>

          <PrivateRoute path={pathList.feed.path} title={pageTitles.feed} component={routes.Feed}/>
          <PrivateRoute path={pathList.user.path} title={pageTitles.user} component={routes.User}/>
          <PrivateRoute path={pathList.usertab.path} title={pageTitles.user} component={routes.User}/>
          <PrivateRoute path={pathList.post.path} title={pageTitles.post} component={routes.Post}/>
          <PrivateRoute path={pathList.media.path} title={pageTitles.media} component={routes.Media}/>
          <PrivateRoute path={pathList.album.path} title={pageTitles.album} component={routes.Album}/>
          <PrivateRoute path={pathList.album_edit.path} title={pageTitles.album} component={routes.Album}/>
          <PrivateRoute exact={true} path={pathList.promotion.path} title={pageTitles.promotion} component={routes.Promotion}/>
          <PrivateRoute exact={true} path={pathList.promotion_create.path} title={pageTitles.promotion} component={routes.Promotion}/>
          <PrivateRoute exact={true} path={pathList.promotion_preview.path} title={pageTitles.promotion} component={routes.Promotion}/>
          <PrivateRoute exact={true} path={pathList.promotion_edit.path} title={pageTitles.promotion} component={routes.Promotion}/>
          <PrivateRoute exact={true} path={pathList.promotion_list.path} title={pageTitles.promotion} component={routes.Promotion}/>
          <PrivateRoute exact={true} path={pathList.promotion_detail.path} title={pageTitles.promotion} component={routes.Promotion}/>
          <PrivateRoute exact={true} path={pathList.chat.path} title={pageTitles.chat} component={routes.Chat}/>
          <PrivateRoute exact={true} path={pathList.search.path} title={pageTitles.search} component={routes.Search}/>
          <PrivateRoute exact={true} path={pathList.polling.path} title={pageTitles.polling} component={routes.Polling}/>
          <Redirect exact={true} from="/login" to="/" />
          <Route exact={true} title={pageTitles.notFound} component={routes.NotFoundPage} /> 
        </Switch>
      </main>
      
    );
  }
}

export default RouteComponent;
